/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/112-bubbles3': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" d="M17 14.081c0 .711.407 1.327 1 1.628v.249a3.71 3.71 0 01-3.207-1.125 5.03 5.03 0 01-1.293.168c-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4 4.5 1.791 4.5 4c0 .865-.309 1.665-.834 2.32a1.81 1.81 0 00-.166.761zM3.604 3.456C2.569 4.297 2 5.378 2 6.5c0 .63.175 1.24.52 1.815.356.592.89 1.134 1.547 1.566.474.312.793.812.878 1.373.028.187.046.376.053.564.117-.097.23-.201.342-.312a2 2 0 011.666-.57c.327.042.662.063.994.063v2c-.424 0-.84-.027-1.246-.079-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.158 10.359.001 8.539.001 6.499c0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336a6.083 6.083 0 00-2.067-.509c-.18-.876-.709-1.7-1.535-2.371a6.299 6.299 0 00-1.932-1.054C9.687 2.134 8.858 1.999 8 1.999s-1.687.135-2.464.402c-.73.251-1.38.605-1.932 1.054z"/>'
  }
})
